export const environment = {
    webApiUrl: 'https://tracetool-webapi-test.azurewebsites.net/Api/'
};